import OtherProjectLink from './OtherProjectLink';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import WarningIcon from '@material-ui/icons/Warning';
import React from 'react';
import PrimaryButton from './PrimaryButton';
import { globalStyles as styles } from './style/gstheme';
import { getProjectFromGraph } from './utils/utils';

class UsedBy extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      open: true
    };
  }

  exit = () => {
    this.setState({ open: false });
    this.props.onExit();
  }

  render() {

    const { message, classes, title, usedResources, graph, defaultLang } = this.props;
    const usedGraphs = usedResources ? [...new Set(usedResources.map(ur => ur.inNamedGraph))].sort() : [];

    return (
      <Dialog data-test="warning-dialog" open={this.state.open} onClose={this.exitWarning} aria-labelledby="warning-dialog-title" >
        <DialogTitle disableTypography className={classes.mainHeading} id="warning-dialog-title">
          {title || "We Need to Let You Know ..."} <WarningIcon style={{ float: 'right' }} fontSize="large" /></DialogTitle>
        <DialogContent>
          {Array.isArray(message) ?
            message.map((line, index) =>
              <DialogContentText
                key={index}
                className={classes.dialogText}
                paragraph>
                <span data-test={"warning-line-" + index} style={{ display: 'block' }}>{line}</span>
              </DialogContentText>
            )
            :
            <DialogContentText data-test={"warning-line"} className={classes.dialogText} paragraph>{message}</DialogContentText>
          }
          {usedGraphs.map(ug => {
            return <OtherProjectLink
              id={getProjectFromGraph(ug)}
              key={ug}
              handleNotAvailable={true}
              graph={ug}
              sourceGraph={graph}
              defaultLang={defaultLang}
              viewLang={defaultLang}
              isReadOnly={true} />;
          })}
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <PrimaryButton onClick={this.exit}>Close</PrimaryButton>
        </DialogActions>
      </Dialog>
    );
  }
}

UsedBy.propTypes = {
  title: PropTypes.string,
  usedResources: PropTypes.array,
  message: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ]),
  graph: PropTypes.string,
  defaultLang: PropTypes.string,
  classes: PropTypes.object,
  onExit: PropTypes.func
};

export default withStyles(styles)(UsedBy);